var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"value":_vm.value,"config":{ format: 'DD-MMM-YYYY', useCurrent: false }},on:{"input":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }